import { Injectable } from '@angular/core';
import {Order} from "../model/Order";
import {Http, Headers, RequestOptions, Response} from "@angular/http";

import 'rxjs/add/operator/toPromise';
import {State} from "../model/State";
import {AuthenticationService} from "./authentication.service";
import {environment} from "../../environments/environment";

@Injectable()
export class OrderService {

    orderUrl = environment.instantPaiementApi + "orders";

    constructor(private http: Http,
                private authenticationService: AuthenticationService) {}

    getOrder(id: number): Promise<Order> {
        let headers = new Headers({ 'Content-Type': 'application/json'});
        let options = new RequestOptions({ headers: headers });
        return this.http.get(this.orderUrl + "/" + id, options)
            .toPromise()
            .then(response => response.json() as Order)
            .then(undefined, (error) => { return error; })
            .catch(this.handleError);
    }

    getListOrderByState(email: string, state: State) : Promise<Order[]> {
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.authenticationService.getToken() });
        let options = new RequestOptions({ headers: headers });
        let params = "";
        if(email) {
            if(!params) params += "?";
            params += "emailClient=" + email;
        }
        if(state) {
            if(!params) params += "?";
            params += "state=" + state.id;
        }
        return this.http.get(this.orderUrl + params, options)
            .toPromise()
            .then(response => response.json() as Order[])
            .then(undefined, (error) => {
                if(error.json().error.code == 401) this.authenticationService.logout();
                return error;
            })
            .catch(this.handleError);
    }

    postOrder(order:Order): Promise<Order> {
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.authenticationService.getToken() });
        let options = new RequestOptions({ headers: headers });
        return this.http.post(this.orderUrl, order, options).toPromise()
            .then(response => response.json() as Order)
            .then(undefined, (error) => {
                if(error.json().error.code == 401) this.authenticationService.logout();
                return error;
            })
            .catch(this.handleError);
    }

    patchOrderState(order:Order, state:State): Promise<boolean> {
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.authenticationService.getToken() });
        let options = new RequestOptions({ headers: headers });
        return this.http.patch(this.orderUrl + "/" + order.id, "{\"state\": " + JSON.stringify(state) + "}", options).toPromise()
            .then(undefined, (error) => {
                if(error.json().error.code == 401) this.authenticationService.logout();
                return error;
            })
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body.data || { };
    }

}


// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/services/order.service.ts